import React, {useRef, useState} from 'react';
import {Chip, Divider, IconButton, ListItem, ListItemText, Popover, Stack, Typography,} from '@mui/material';
import {FixedSizeList as VirtualList} from 'react-window';
import Icons from "components/DmpIcons/icons";
import CustomOutlinedInput from "../../../components/CustomOutlinedInput/CustomOutlinedInput";

const SelectedCampaigns = ({ selectedCampaigns = [], handleRemoveCampaign, handleClearAllCampaigns }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const anchorRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');


        const handleClose = () => {
        setAnchorEl(null);
        setSearchTerm('');
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredCampaigns = selectedCampaigns.filter(campaign =>
        campaign.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const Row = ({ index, style }) => {
        const campaign = filteredCampaigns[index];
        return (
            <ListItem style={style} key={campaign.id} disablePadding>
                <ListItemText
                    primary={
                        <Typography fontSize="12px" fontFamily="Inter">
                            {campaign.name}
                        </Typography>
                    }
                />
                <IconButton
                    onClick={() => handleRemoveCampaign(campaign.id)}
                    size="small"
                    style={{ marginLeft: "8px" }}
                    aria-label={`Remove ${campaign.name}`}
                >
                    <Icons.ActionsIcons.DeleteIcon style={{ width: "12px", height: "12px" }} />
                </IconButton>
            </ListItem>
        );
    };

    const open = Boolean(anchorEl);
    const id = open ? 'selected-hotels-popover' : undefined;

    const handleMoreClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <div className="selected-hotels">
            <div ref={anchorRef} style={{ position: 'relative' }}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                    {(!selectedCampaigns || selectedCampaigns.length === 0) ? (
                        <Chip
                            label="No Campaign"
                            color="primary"
                            style={{
                                minWidth: "80px",
                                height: "22px",
                                border: "1px solid #C5C2C2",
                                margin: '4px',
                                fontSize: "12px",
                                fontFamily: "Inter",
                                fontWeight: 400
                            }}
                        />
                    ) : (
                        // Sinon, afficher uniquement le chip "+X more"
                        <Chip
                            label={`${selectedCampaigns.length} ${selectedCampaigns.length === 1 ? 'Campaign' : 'Campaigns'}`}
                            color="primary"
                            style={{
                                minWidth: "80px",
                                height: "22px",
                                border: "1px solid #C5C2C2",
                                margin: '4px',
                                fontSize: "10px",
                                fontFamily: "Inter",
                                fontWeight: 400,
                                cursor: "pointer"
                            }}
                            onClick={handleMoreClick}
                        />
                    )}

                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            PaperProps={{
                                style: { width: '350px', maxHeight: '500px' },
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
                                <div style={{ padding: '16px 16px 8px 16px', flexShrink: 0 }}>
                                    <Typography fontSize={"12px"} fontFamily={"Inter"} >ALL SELECTED CAMPAIGNS</Typography>
                                    <Divider style={{ marginTop: '8px' }} />
                                    {selectedCampaigns.length > 0 && (
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    handleClearAllCampaigns();
                                                    handleClose();
                                                }}
                                                aria-label="Remove all campaigns"
                                            >
                                                <Icons.ActionsIcons.DeleteIcon style={{ width: "14px", height: "14px" }} />
                                                <Typography fontSize="10px" style={{ marginLeft: 4 }}>Clear all</Typography>
                                            </IconButton>
                                        </div>
                                    )}

                                </div>

                                <div style={{ padding: '5px 16px 16px 16px', overflowY: 'auto', flexGrow: 1 }}>
                                    <CustomOutlinedInput
                                        placeholder={"Search campaigns..."}
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    {filteredCampaigns.length > 0 ? (
                                        <VirtualList
                                            height={300}
                                            itemCount={filteredCampaigns.length}
                                            itemSize={35}
                                            width={'100%'}
                                        >
                                            {Row}
                                        </VirtualList>
                                    ) : (
                                        <Typography fontSize={"12px"} fontFamily={"Inter"} variant="body2">No campaigns found.</Typography>
                                    )}
                                </div>
                            </div>
                        </Popover>

                </Stack>
            </div>
        </div>
    );
};

export default SelectedCampaigns;
